<template>
  <div class="w3-container about">

  </div>
</template>

<script>
  import {
    mapGetters,
    mapActions
  } from "vuex";
  export default {
    name: "About",
    data() {
      return {
        msg: ""
      };
    },
    beforeCreated() {},
    created: function() {},
    mounted() {},
    // computed: mapGetters(["seller"]),
    beforeDestroy() {},
    destroy() {}
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .about {
    padding-top: 10px;
  }
  
  .disclaimer {
    padding-top: 40px;
    /* color: #CCCCCC; */
    /*Color of Disclaimer Text*/
    font-size: 12px;
    /*Font Size of Disclaimer Text*/
    font-family: Arial, Helvetica, sans-serif;
    /*Web Safe Font Family of Disclaimer Text*/
  }
</style>



// WEBPACK FOOTER //
// src/components/About.vue